"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.connectSuggestedActions = exports.default = void 0;

var _reactFilm = _interopRequireDefault(require("react-film"));

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _connectToWebChat = _interopRequireDefault(require("../connectToWebChat"));

var _SuggestedAction = _interopRequireDefault(require("./SuggestedAction"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function suggestedActionText(_ref) {
  var displayText = _ref.displayText,
      title = _ref.title,
      type = _ref.type,
      value = _ref.value;

  if (type === 'messageBack') {
    return title || displayText;
  } else if (title) {
    return title;
  } else if (typeof value === 'string') {
    return value;
  } else {
    return JSON.stringify(value);
  }
}

var connectSuggestedActions = function connectSuggestedActions() {
  for (var _len = arguments.length, selectors = new Array(_len), _key = 0; _key < _len; _key++) {
    selectors[_key] = arguments[_key];
  }

  return _connectToWebChat.default.apply(void 0, [function (_ref2) {
    var language = _ref2.language,
        suggestedActions = _ref2.suggestedActions;
    return {
      language: language,
      suggestedActions: suggestedActions
    };
  }].concat(selectors));
};

exports.connectSuggestedActions = connectSuggestedActions;

var _default = connectSuggestedActions(function (_ref3) {
  var styleSet = _ref3.styleSet;
  return {
    styleSet: styleSet
  };
})(function (_ref4) {
  var className = _ref4.className,
      styleSet = _ref4.styleSet,
      suggestedActions = _ref4.suggestedActions;
  return !!suggestedActions.length && _react.default.createElement(_reactFilm.default, {
    autoCenter: false,
    className: (0, _classnames.default)(styleSet.suggestedActions + '', className),
    showDots: false,
    styleSet: styleSet.options.suggestedActionsStyleSet
  }, suggestedActions.map(function (_ref5, index) {
    var displayText = _ref5.displayText,
        image = _ref5.image,
        text = _ref5.text,
        title = _ref5.title,
        type = _ref5.type,
        value = _ref5.value;
    return _react.default.createElement(_SuggestedAction.default, {
      buttonText: suggestedActionText({
        displayText: displayText,
        title: title,
        type: type,
        value: value
      }),
      displayText: displayText,
      image: image,
      key: index,
      text: text,
      type: type,
      value: value
    });
  }));
});

exports.default = _default;